import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Lock = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
d="M11 12C11 7.02944 15.0294 3 20 3C24.9706 3 29 7.02944 29 12V16H31C32.6569 16 34 17.3431 34 19V33C34 34.6569 32.6569 36 31 36H9C7.34315 36 6 34.6569 6 33V19C6 17.3431 7.34315 16 9 16H11V12ZM13 16H27V12C27 8.13401 23.866 5 20 5C16.134 5 13 8.13401 13 12V16ZM9 18C8.44772 18 8 18.4477 8 19V33C8 33.5523 8.44772 34 9 34H31C31.5523 34 32 33.5523 32 33V19C32 18.4477 31.5523 18 31 18H9Z"                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Lock;
